'use strict';

var Sugar = require('sugar-core');

require('./build/buildMathAliasesCall');

module.exports = Sugar.Number.tan;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/tan.js
// module id = 742
// module chunks = 0